import { render } from "./Navigation.vue?vue&type=template&id=2eab43ed&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=2eab43ed&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\front-on\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eab43ed"]])

export default __exports__